export default __webpack_public_path__ + "static/media/white_knight.b83de34d.png";